import keyMirror from 'keymirror';

const STEP = keyMirror({
  essayInstructions: null,
  essayWriting: null,
  essayReview: null,
  examNavigation: null,
  examReview: null,
  examSummary: null,
  loading: null,
  quizConfirmation: null,
  quizExplanation: null,
  quizPrompt: null,
  sessionOptions: null,
  sessionSelect: null,
  summary: null,
});

export default STEP;
